import { TEST_ID } from './constants';
import { ICON_BY_SEVERITY } from './severityShapes';
import type { FunctionComponent, Props, Severity } from './types';

import styles from './styles.module.scss';

const SEVERITY_CLASS: Record<Severity, string> = {
    advisory: styles.advisory,
    critical: styles.critical,
    info: styles.info,
    prohibited: styles.prohibited,
    safe: styles.safe,
    warning: styles.warning
};

const MiniSeverityIcon: FunctionComponent<Props> = ({
    className = '',
    severity,
    testId = TEST_ID
}) => {
    const severityClass = SEVERITY_CLASS[severity];

    return (
        <svg
            className={`${styles.miniSeverityIcon} ${severityClass} ${className}`}
            data-testid={testId}
            height='14'
            viewBox='0 0 14 14'
            width='14'
            xmlns='http://www.w3.org/2000/svg'>
            {ICON_BY_SEVERITY[severity]}
        </svg>
    );
};

export default MiniSeverityIcon;
